import React, { useEffect, useState } from 'react';
import { useAuth } from "../../contexts/AuthContexts"
import { Link, useNavigate } from "react-router-dom"
import { Header } from "../../components/Header";
import { Container, Content, ProfileCard, Button, InfoCard, ProfileActivity, UploadContainer } from "./styles";

import profile from "../../assets/profile.jpg"; // provisório
import { FiChevronDown } from "react-icons/fi";

import appleIcon from "../../assets/icon-apple.svg";
import fireIcon from "../../assets/icon-fire.svg"

import { db, storage } from '../../firebase'
import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import { setDoc, doc } from "firebase/firestore"

import { useUser } from '../../contexts/UserContexts';

export const Profile = () => {
    const { currentUser, logout } = useAuth();
    const { userInfo } = useUser();

    const [files, setFiles] = useState([]);
    const [url, setURL] = useState("");

    const [ error, setError ] = useState("");
    const [ userName, setUserName ] = useState();
    const [ userWeight, setUserWeight ] = useState();
    const [ userHeight, setUserHeight ] = useState();
    const [ userKcals, setUserKcals ] = useState();
    const [ userTrains, setUserTrains ] = useState();
    const [ editMode, setEditMode ] = useState(false);
    const [ loading, setLoading ] = useState(true);
    const [ weekPhoto, setWeekPhoto ] = useState(false); 
    const [ messages, setMessages ] = useState(["", "", ""]);
    const history = useNavigate();

    const handleLogout = async () => {
        setError("");

        try {
            await logout();
            history("/")
        } catch {
            setError("Failed to log out")
        }
    };

    const getInfoFromContext = () => {
        if(!currentUser || !currentUser.uid) return;
        setLoading(true);

        setUserName(userInfo.name);
        setUserWeight(userInfo.currentWeight);
        setUserHeight(userInfo.height);
        setUserKcals(userInfo.dietKcal);
        setUserTrains(userInfo.weekTrains);

        setLoading(false);
    }
    

    const handleWeekPhoto = () => {
        const currentDate = new Date();
        const photoDay =  (parseInt(currentDate.getDay()) === 6) || (parseInt(currentDate.getDay()) === 0);
        setWeekPhoto(photoDay);
    }

    useEffect(() => {
        getInfoFromContext();
        handleWeekPhoto();
    }, []);


    const handleChange = (e, type) => {
        if(e.target.files[0].size > 4000000){
            e.preventDefault();
            alert("Foto pesada demais Fella! Máx de 5MB.")
            e.target.value = "";
            let aux = [...files];
            aux[type] = null;
            setFiles(aux);
            return;
        }
        let aux = [...files];
        aux[type] = e.target.files[0];
        setFiles(aux);
    }

    //photoType - (0: frontal superior, 1: frontal geral, 2: costas)
    const handleUpload = async (e, type) => {
        e.preventDefault()
        if(!currentUser || !currentUser.uid) return;
        if(!files || !files[type]){
            let aux = [...messages];
            aux[type] = "Error!"
            setMessages(aux);
            return;
        }

        setLoading(true);
        try {
            const currentDate = new Date();
            const weekDate = new Date(currentDate.setDate(currentDate.getDate() - (currentDate.getDay() + 6)%7));
            const isoDate = String(weekDate.getFullYear() + "-" + String(parseInt(weekDate.getMonth() + 1)).padStart(2, '0') + "-" + String(weekDate.getDate()).padStart(2, '0'));
            // referência para local do storage
            const imageRef = ref(storage, `/user_uploads/${currentUser.uid}/week_photo/${isoDate}_${type}`);

            await uploadBytes(imageRef, files[type]).then((snapshot) => {
                console.log('Uploaded a file!');
            });

            await getDownloadURL(imageRef)
            .then(url_ => setURL(url_))

            // DB
            await setDoc(doc(db, "users", currentUser.uid), {
                user_photos: {
                    [isoDate] : true,
                },
            }, {merge: true});

            let aux = [...messages];
            aux[type] = "Sucesso!"

            setMessages(aux);

        } catch(e) {
            console.log(e);
            let aux = [...messages];
            aux[type] = "Error!"

            setMessages(aux);
        }

        setLoading(false);
    }

  return (
    <Container>
        <Header />
        <Content>
            <ProfileCard>
                <img src={profile} alt="dev" />
                <div className="profile-box-info">
                    <h2>{ userName }</h2>
                </div>
            </ProfileCard>
            <Link className="update-profile" to="/update-profile">
                <button disabled={loading} onClick={()=>{setEditMode(!editMode)}}>Editar <FiChevronDown /></button>
            </Link>
            <InfoCard>
                <div className='info-box'>
                    <div>{userHeight ? userHeight + " cm" : "-"}</div>
                    <div className='category'>Altura</div>
                </div>
                <div className='info-box'>
                    <div>{userWeight ? userWeight + " kg" : "-"}</div>
                    <div className='category'>Peso</div>
                </div>
                <div className='info-box'>
                    <div>{ userWeight && userHeight ? ((userWeight/(userHeight*userHeight))*10000).toFixed(1) : "-"}</div>
                    <div className='category'>IMC</div>
                </div>
            </InfoCard>
            <div className='category'>Atividade</div>
            <ProfileActivity>
                <div className='switchContent'>
                    <div className='iconGroup'>
                        <img src={fireIcon} alt="fire" />
                        <div className='iconGroupTitle' style={{"color":"#FF4704"}}>Treino</div>
                    </div>
                    <div className='category'>{userTrains ? userTrains + " Treinos" : "-"}</div>
                </div>
                <div style={{"backgroundColor": "#C1C1C1", "width": "100%", "height": "1px", "fontSize": "1px", "lineHeight": "1px"}}> </div>
                <div className='switchContent'>
                    <div className='iconGroup'>
                        <img src={appleIcon} alt="apple" />
                        <div className='iconGroupTitle' style={{"color":"#FA124F"}}>Dieta</div>
                    </div>
                    <div className='category'>{userKcals ? userKcals + " Calorias" : "-"}</div>
                </div>
            </ProfileActivity>
            {weekPhoto && <UploadContainer>
                <h3>Foto Semanal [BETA]</h3>
                <form onSubmit={(e) => handleUpload(e, 0)}>
                    <input type="file" onChange={(e) => handleChange(e, 0)}/>
                    <button disabled={loading}>Foto Frontal Superior</button>
                </form>
                <span>{messages[0]}</span>
                <form onSubmit={(e) => handleUpload(e, 1)}>
                    <input type="file" onChange={(e) => handleChange(e, 1)}/>
                    <button disabled={loading}>Foto Frontal Total</button>
                </form>
                <span>{messages[1]}</span>
                <form onSubmit={(e) => handleUpload(e, 2)}>
                    <input type="file" onChange={(e) => handleChange(e, 2)}/>
                    <button disabled={loading}>Foto Costas</button>
                </form>
                <span>{messages[2]}</span>
            </UploadContainer>}
            <Button disabled={loading} onClick={handleLogout}>Sair</Button>
            {error && <div>{error}</div>}
        </Content>
    </Container> 
  );
}
